import {mapGetters} from 'vuex'

export var websocketMixin = {
  mixins:[],
  watch: { 
  },
  
  data(){
    return{
    }
  },
  computed: {
    ...mapGetters('websocket',['isOnline','hasLeaderChangeRequest']),
    isOffline(){
      return !this.isOnline;
    }
  },
  methods: {
    
  }
}
